import { selector } from 'recoil';
import { coverableChangesSelector } from './coverableChangesSelector';

export const containsAddCoverageChangeSelector = selector<boolean>({
    key: 'containsAddCoverageChangeSelector',
    get: ({ get }) => {
        const coverableChanges = get(coverableChangesSelector);
        return coverableChanges.some((coverable) =>
            coverable.changes.some(
                (change) =>
                    change?.coverageId &&
                    !change?.before?.booleanValue &&
                    change?.after?.booleanValue
            )
        );
    }
});
